<template>
  <div>
    <div style="margin-top: 10px;margin-bottom: 10px;text-align: center;">
      <span style="font-size: 20px;">{{ user.companyTitle + '借款申请单' }}</span>
    </div>
    <div>
      <el-form>
        <div style="margin-bottom: 10px;">
          <el-row>
            <el-col :span="9" center>申请部门：<span v-text="user.groupName"></span></el-col>
            <el-col :span="3" center>日期：&nbsp;&nbsp;&nbsp;&nbsp;<span v-text="rq"></span></el-col>
            <el-col :span="2" center> <el-icon name="arrow" size="20px"></el-icon></el-col>
            <el-col :span="3" center>单据号：</el-col>
            <el-col :span="1" center><span v-text="djh"></span></el-col>
            <el-col :span="3"><span style="float: right">单位：元</span></el-col>
          </el-row>
        </div>
        <table style="width: 75%;margin: 1px auto">
          <col style="width: 5%">
          <col style="width: 13%">
          <col style="width: 5%">
          <col style="width: 5%">
          <col style="width: 5%">
          <col style="width: 5%">
          <tr>
            <td><span style="line-height: 44px" class="star">借款人</span></td>
            <td style="text-align: left">
              <el-select v-model="jkr" placeholder="请稍后正在自动填充.." style="" filterable @change="changejkr">
                <el-option
                  v-for="item in optionsFyBxUser"
                  :key="item.subjectCode"
                  :label="item.subjectName"
                  :value="[item.subjectName,item.subjectCode,item.dictCode,item.dictName]">
                </el-option>
              </el-select>
            </td>
            <td><span>集团总裁</span></td><td></td>
            <td><span>集团CFO</span></td><td></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px">款项用途</span></td>
            <td><el-input v-model="kxyt" placeholder="请输入款项用途"></el-input></td>
            <td><span style="line-height: 44px">总经理</span></td><td></td>
            <td><span>董事长</span></td><td></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px" class="star">金额（小写）</span></td>
            <td><el-input-number v-model="jexx" placeholder="请输入金额" style="width: 100%" :controls="false" @change="jeChange"></el-input-number></td>
            <td><span style="line-height: 44px">总会计师</span></td><td></td>
            <td><span>副总经理</span></td><td></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px">金额（大写）</span></td>
            <td><span v-text="jedx"></span></td>
            <td><span style="line-height: 44px">财务部长</span></td><td></td>
            <td><span>部门负责人</span></td><td></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px">出差事由</span></td>
            <td><span v-text="ccsy"></span></td>
            <td><span>审核会计</span></td><td></td>
            <td><span>经办人</span></td><td></td>
          </tr>
          <tr>
            <td><span style="line-height: 44px">出差地点</span></td>
            <td><span v-text="ccdd"></span></td>
            <td><span style="line-height: 44px">出差依据</span></td>
            <td colspan="3"><!--<el-input v-model="ccyj" placeholder="请输入备注"></el-input>--></td>
          </tr>
        </table>
        <br>
        <el-form-item size="large">
          <el-button type="primary" :disabled="saveBtn" @click="submitForm">保存</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-tabs v-model="activeName" style="width: 75%;margin: auto">
      <el-tab-pane label="借款人借款情况" name="second">
        <table style="width: 98%;margin: 2px auto">
          <tr>
            <td>
              <span style="line-height: 44px">累计借款</span>
            </td>
            <td>
              <span v-text="ljjk"></span>
            </td>
            <td>
              <span>已还款</span>
            </td>
            <td>
              <span v-text="yhk"></span>
            </td>
            <td>
              <span>借款金额</span>
            </td>
            <td>
              <span v-text="jkje"></span>
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="个人明细" name="third">
        <table style="width: 98%;margin: 2px auto">
          <tr>
            <td>
              <span style="line-height: 44px">日期</span>
            </td>
            <td>
              <span>摘要</span>
            </td>
            <td>
              <span>凭证号</span>
            </td>
            <td>
              <span>票据号</span>
            </td>
            <td>
              <span>借款</span>
            </td>
            <td>
              <span>还款</span>
            </td>
            <td>
              <span>余额</span>
            </td>
          </tr>
          <tr>
            <td>
              <span style="line-height: 44px">期初</span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span>0.00</span>
            </td>
          </tr>
          <tr>
            <td>
              <span style="line-height: 44px">期末</span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span></span>
            </td>
            <td>
              <span>0.00</span>
            </td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import publicBuill from '../../../components/reimbursement/js/publicBuill'

export default {
  name: 'oaJKsqd',
  data() {
    return {
      djh: '',
      jkr: '',
      jkrid: '',
      jexx: '',
      jedx: '',
      rq: '',
      lrr: '',
      lrrq: '',
      flowId: '',
      ccdd: '',
      ccsy: '',
      ccyj: '',
      kxyt: '',
      sfpj: '',
      bz: '',
      ljjk: '0.00',
      yhk: '0.00',
      jkje: '0.00',
      optionsFyBxnr: [],
      optionsFyBxUser: [],
      config: {
        fixed: true,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        loading: false,
        searchTables: false,
        height: '16vh',
        indexWidth: '100%'
      },
      activeName: 'second',
      tableData: [],
      tableLabel: [
        {
          label: '日期',
          prop: 'rq',
          width: '120'
        },
        {
          label: '审核人',
          prop: 'shr',
          width: '120',
          search: '',
          aligin: 'left'
        },
        {
          label: '审核结果',
          prop: 'shjg',
          width: '120',
          aligin: 'left'
        },
        {
          label: '通过金额',
          prop: 'tgje',
          width: '120'
        },
        {
          label: '审核意见',
          prop: 'shyj',
          width: '360'
        }

      ],
      user: {},
      saveBtn: true

    }
  },
  mounted() {
    publicBuill.getFyBxUser().then(res => {
      this.optionsFyBxUser.forEach(value => {
        if (value.subjectName === this.user.userName) {
          const itemArr = [value.subjectName, value.subjectCode, value.dictCode, value.dictName]
          this.changejkr(itemArr)
        }
      })
    })
    this.user = localStorage
    this.rq = publicBuill.dateToString(new Date())
    if (this.user.userNo === '51544') {
      this.user.companyTitle = '吴忠仪表检修服务分公司'
      this.user.companyCode = '10'
      this.saveBtn = false
    } else {
      publicBuill.companyNameQuery(this.user.company).then(res => {
        if (!this.user.companyTitle || this.user.companyTitle === '' || !this.user.companyId || this.user.companyId === '') {
          this.saveBtn = true
          this.$message.error('公司信息获取失败，请联系管理员！！！')
        } else {
          this.saveBtn = false
        }
      })
    }
  },
  created() {
    publicBuill.setThis(this)
  },
  methods: {
    changejkr(event) {
      this.jkr = event[0]
      this.jkrid = event[1]
    },
    submitForm() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        djh: this.djh,
        jkr: this.jkr,
        jkrid: this.jkrid,
        bmbm: localStorage.getItem('deptNo'),
        bmmc: localStorage.getItem('groupName'),
        kxyt: this.kxyt,
        je: this.jexx,
        lrr: localStorage.getItem('userName'),
        lrrId: localStorage.getItem('userNo'),
        ccsy: this.ccsy,
        ccyj: this.ccyj,
        ccdd: this.ccdd,
        yjccsj1: '',
        yjccsj2: '',
        yjts: '',
        flowId: this.flowId,
        rejected: '0',
        companyId: this.user.companyId
      }
      if (data.jkr === '') {
        this.$message.error('借款人不能为空')
        loading.close()
      } else if (this.jexx <= 0) {
        this.$message.error('金额为大于0的数字')
        loading.close()
      } else {
        this.$post('/fesback/loadForm/save.z', data).then(response => {
          if (response.success === true) {
            this.$message.success(response.message)
            this.resetForm()
          } else {
            this.$message.error(response.message)
          }
          loading.close()
        })
      }
    },
    jeChange() {
      this.jedx = publicBuill.convertCurrency(this.jexx)
    },
    resetForm() {
      this.kxyt = ''
      this.jexx = ''
      this.ljjk = '0.00'
      this.yhk = '0.00'
      this.jkje = '0.00'
      this.rq = publicBuill.dateToString(new Date())
    }
  }
}
</script>
<style scoped>
  table,table tr th, table tr td {
    border:1px solid #000000;
  }
  .star::after {
    content: '*';
    color: #ff0000;
    margin-left: 4px;
  }
</style>
